import { formatUtcToString } from './formatUtcToString'

const parseSafeDate = (val) => {
  if (!val) return new Date()
  if (val instanceof Date) return isNaN(val.getTime()) ? new Date() : val
  if (typeof val === 'string') {
    const formatted = val.includes(' ') && !val.includes('T') ? val.replace(' ', 'T') : val
    const d = new Date(formatted)
    if (!isNaN(d.getTime())) return d
  }
  const fallback = new Date(val)
  return isNaN(fallback.getTime()) ? new Date() : fallback
}

export const calculateSessionTime = (questionData = {}) => {
  try {
    const timeStart = parseSafeDate(questionData?.time_start)
    const timeEnd = new Date()

    const diffMs = timeEnd - timeStart
    const diffSec = Math.max(0, Math.floor(diffMs / 1000))

    const hours = Math.floor(diffSec / 3600)
    const minutes = Math.floor((diffSec % 3600) / 60)
    const seconds = diffSec % 60

    const durasiString =
      hours > 0
        ? `${hours} jam ${minutes} menit ${seconds} detik`
        : `${minutes} menit ${seconds} detik`

    return {
      time_start: formatUtcToString(timeStart),
      time_end: formatUtcToString(timeEnd),
      durasi: durasiString,
    }
  } catch (err) {
    console.error('Gagal menghitung waktu sesi:', err)
    const now = new Date()
    return {
      time_start: formatUtcToString(now),
      time_end: formatUtcToString(now),
      durasi: '0 detik',
    }
  }
}

